import { render, staticRenderFns } from "./TvodTermsOfUse.vue?vue&type=template&id=4cd34306&scoped=true&"
import script from "./TvodTermsOfUse.vue?vue&type=script&lang=js&"
export * from "./TvodTermsOfUse.vue?vue&type=script&lang=js&"
import style0 from "./TvodTermsOfUse.vue?vue&type=style&index=0&id=4cd34306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd34306",
  null
  
)

component.options.__file = "TvodTermsOfUse.vue"
export default component.exports